import { EnumBase } from 'hay-core-react';
class ConfiguracaoImagemTelaInicialFormatoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.imagemtelainicialformato.padrao',
                'main.configuracao.imagemtelainicialformato.estendida',
            ],
            'main.configuracao.imagemtelainicialformato.padrao'
        );
    }
}

const instance = new ConfiguracaoImagemTelaInicialFormatoEnum();
export default instance;
